<template>
  <v-dialog persistent v-model="showAutoChangeDialog" max-width="480">
    <v-container fluid class="grey lighten-5">
      <v-row no-gutters v-for="change in changes" v-bind:key="change.field_name">
        <v-card outlined>
          <v-card-title>
            <span class="subtitle-1">Berechnung von "{{ change.field_name }}"</span>
          </v-card-title>
          <v-card-text>
            {{ change.message }}
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="discard(change)">Verwerfen</v-btn>
            <v-btn text @click="accept(change)" color="primary">Akzeptieren</v-btn>
          </v-card-actions>
        </v-card>
      </v-row>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  name: "AutoChangeDialogView",
  props: {
    changes: Array,
    showThis: Boolean,
  },
  watch: {
    showThis: function(st) {
      this.showAutoChangeDialog = st;
    },
    showAutoChangeDialog: function(show) {
      if (show === false) {
        this.$emit("discard");
      }
    },
  },
  methods: {
    discard(change) {
      change.callback({ accept: false });
      this.changes.splice(this.changes.indexOf(change), 1);
      this.close_if_empty();
    },
    accept(change) {
      change.callback({ accept: true });
      this.changes.splice(this.changes.indexOf(change), 1);
      this.close_if_empty();
    },
    close_if_empty() {
      if (this.changes.length === 0) {
        this.showAutoChangeDialog = false;
      }
    },
  },
  mounted() {
    //this.init()
  },
  data: () => ({
    showAutoChangeDialog: false,
  }),
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
